import { useEffect, RefObject, useCallback, useState } from 'react';
import {
  createDirectionFn,
  getElementHeight,
  getVisibleCondition,
  getHasClassName,
  addClassName,
  removeClassName,
} from './utils';

export const useStickyHeader = (
  header: RefObject<HTMLElement>,
  className: string,
  disableSticky: boolean
) => {
  const [getScrollDirection] = useState(() => createDirectionFn());

  const onScroll = useCallback(() => {
    const { current } = header;

    // eslint-disable-next-line no-useless-return
    if (current === null) return;

    const height = getElementHeight(current);

    const direction = getScrollDirection(window.scrollY);
    const headerVisible = getVisibleCondition(window.scrollY, height);

    const hasClass = getHasClassName(current, className);

    if (direction === 'top' && !headerVisible && !hasClass) {
      addClassName(current, className);
    }

    if (headerVisible || (direction === 'bottom' && hasClass)) {
      removeClassName(current, className);
    }
  }, [header, getScrollDirection, className]);

  useEffect(() => {
    if (!__IS_SERVER__ && !disableSticky) {
      window.addEventListener('scroll', onScroll);
    }

    return () => {
      if (!__IS_SERVER__ && !disableSticky) {
        window.removeEventListener('scroll', onScroll);
      }
    };
  }, [disableSticky, onScroll]);
};
